const LAYOUT_PARAM = 'layout';
const LAYOUT_VALUE = 'fluid';
const FLOW_PARAM = 'flow';

export interface DfdEmbedUrlOptions {
  flowId?: string;
  widgetId?: string;
}

// The embed host is its own variable: outside production it differs from the
// VITE_DFD_HOST_URL the live-chat SDK uses.
const getEmbedBase = () => {
  const hostUrl = import.meta.env.VITE_DFD_EMBED_HOST_URL;
  const tenantId = import.meta.env.VITE_DFD_ID;

  if (!hostUrl || !tenantId) {
    throw new Error(
      'DFD embed is not configured: VITE_DFD_EMBED_HOST_URL and VITE_DFD_ID are both required',
    );
  }

  return { hostUrl, tenantId };
};

const asConfiguredId = (id: string | undefined) =>
  id && id.trim() !== '' ? id : undefined;

/**
 * - neither ID: `/{tenantId}/embed?layout=fluid`
 * - `flowId`:   `/{tenantId}/embed?layout=fluid&flow={flowId}`
 * - `widgetId`: `/{tenantId}/embed/w/{widgetId}?layout=fluid`
 */
export const buildDfdEmbedUrl = ({
  flowId,
  widgetId,
}: DfdEmbedUrlOptions = {}): string => {
  const flow = asConfiguredId(flowId);
  const widget = asConfiguredId(widgetId);

  if (flow && widget) {
    throw new Error(
      'buildDfdEmbedUrl: pass either flowId or widgetId, not both',
    );
  }

  const { hostUrl, tenantId } = getEmbedBase();

  const path = widget
    ? `/${tenantId}/embed/w/${encodeURIComponent(widget)}`
    : `/${tenantId}/embed`;

  const url = new URL(path, hostUrl);
  url.searchParams.set(LAYOUT_PARAM, LAYOUT_VALUE);
  if (flow) {
    url.searchParams.set(FLOW_PARAM, flow);
  }

  return url.toString();
};

export const getDfdTargetOrigin = (src: string): string => new URL(src).origin;
